import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { path } from '../../lib/ramda'
import { getValueFromMatrix } from '../../helpers/UtilHelper'
import {
  disableScrolling,
  enableScrolling,
} from '../../states/scrolling/actions'
import { ScreenSizeHelper } from '../../helpers/ScreenSizeHelper'
import { PageCarouselViewItem } from './PageCarouselViewItem'

const StyledCarouselView = styled.div`
  overflow: hidden;
  position: relative;
  touch-action: pan-y;
`

const CarouselContent = styled.div``

const StyledOverlay = styled.div`
  background-color: #000;
  width: 1000px;
  height: 1000px;
  opacity: 0;
  position: absolute;
  z-index: 100;
`

const SCROLL_DIRECTION = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL',
}

const TRANSITION_TO_PAGE_MINIMUM_PX = 80

const getElementTransformX = (el) => {
  if (typeof document === 'undefined') {
    return
  }
  const computedStyle = window.getComputedStyle(el, null)
  const matrix = computedStyle.getPropertyValue('transform')
  const valueFromMatrix = getValueFromMatrix(matrix)
  if (!valueFromMatrix) {
    return 0
  }
  return valueFromMatrix.tx
}

interface IPageCarouselViewProps {
  className?: string
  slideIndex: number
  onSlideChange: (index: number) => void
  dispatch: () => void
  screenSize?: string
  items: Array<any>
  element: React.ReactNode
}

class PageCarouselView extends Component<IPageCarouselViewProps> {
  componentDidMount() {
    this.overlayEl.style.display = 'none'
    //this.carouselContainerEl.style.transition = '.3s ease-in-out';
  }

  getPageX(ev) {
    if (ev.pageX !== undefined) {
      this.latestPageX = ev.pageX
      return this.latestPageX
    }

    const touches = path(['touches'], ev)
    if (touches.length && touches.length > 0) {
      this.latestPageX = touches[0].pageX
      return this.latestPageX
    }
    // return the latest if undefined;
    return this.latestPageX
  }

  getPageY(ev) {
    if (ev.pageY !== undefined) {
      this.latestPageY = ev.pageY
      return this.latestPageY
    }

    const touches = path(['touches'], ev)
    if (touches.length && touches.length > 0) {
      this.latestPageY = touches[0].pageY
      return this.latestPageY
    }
    // return the latest if undefined;
    return this.latestPageY
  }

  /* Event Handlers */
  mouseMoveHandler(ev) {
    if (!this.x) {
      return
    }
    if (!this.y) {
      return
    }
    const pageX = this.getPageX(ev)
    const pageY = this.getPageY(ev)

    const movedX = pageX - this.x
    const movedY = pageY - this.y
    if (!this.scrollDirection) {
      const absMovedX = Math.abs(movedX)
      const absMovedY = Math.abs(movedY)
      if (absMovedY === absMovedX) {
        return
      }
      if (absMovedX > absMovedY) {
        const { dispatch } = this.props
        this.scrollDirection = SCROLL_DIRECTION.HORIZONTAL
        dispatch(disableScrolling())
      } else {
        this.scrollDirection = SCROLL_DIRECTION.VERTICAL
        return
      }
    }
    this.overlayEl.style.display = 'block'
    if (this.scrollDirection !== SCROLL_DIRECTION.HORIZONTAL) {
      return
    }
    this.carouselContainerEl.style.transform = `translate(${
      this.currCarouselContainerLeft + movedX
    }px)`
  }

  reset() {
    const { dispatch } = this.props
    this.scrollDirection = null
    this.x = null
    this.y = null
    dispatch(enableScrolling())
  }

  mouseMoveCompleteHandler(ev) {
    ev.stopPropagation()
    //this.carouselContainerEl.style.transition = '.3s ease-in-out';
    if (this.scrollDirection !== SCROLL_DIRECTION.HORIZONTAL) {
      this.reset()
      return
    }
    this.overlayEl.style.display = 'none'
    const { x } = this
    const movedX = this.getPageX(ev)
    const movedDiff = Math.abs(x - movedX)
    this.reset()

    // only if moved more than 10 pixel will transform to the other page
    if (movedDiff < TRANSITION_TO_PAGE_MINIMUM_PX) {
      this.carouselContainerEl.style.transform = this.originalTrasform
      this.originalTrasform = null
      return
    }
    this.originalTrasform = null

    const { slideIndex } = this.props
    const index = slideIndex + (x > this.latestPageX ? 1 : -1)
    if (index < 0) {
      this.carouselContainerEl.style.transform = 'translate(0px)'
      return
    }
    const { noOfItems } = this.props
    if (index >= noOfItems) {
      this.carouselContainerEl.style.transform = `translate(-${this.x}%)`
      return
    }
    this.props.onSlideChange(index)
  }

  mouseStartHandler(ev) {
    ev.stopPropagation()
    this.originalTrasform = this.carouselContainerEl.style.transform
    //this.carouselContainerEl.style.transition = 'initial';
    this.x = this.getPageX(ev)
    this.y = this.getPageY(ev)
    this.scrollDirection = null
    this.currCarouselContainerLeft = getElementTransformX(
      this.carouselContainerEl
    )
  }

  render() {
    const { className, slideIndex, items, element, screenSize } = this.props

    const isSwipeable = ScreenSizeHelper.getScreenSizeValueFromObject(
      screenSize,
      {
        default: false,
      }
    )

    const showItems = []
    if (slideIndex > 0) {
      showItems.push(items[slideIndex - 1])
    }
    showItems.push(items[slideIndex])
    if (slideIndex < items.length - 2) {
      showItems.push(items[slideIndex + 1])
    }
    return (
      <StyledCarouselView
        className={className}
        onMouseDown={isSwipeable ? this.mouseStartHandler.bind(this) : null}
        onTouchStart={isSwipeable ? this.mouseStartHandler.bind(this) : null}
        onMouseUp={
          isSwipeable ? this.mouseMoveCompleteHandler.bind(this) : null
        }
        onTouchEnd={
          isSwipeable ? this.mouseMoveCompleteHandler.bind(this) : null
        }
        onMouseMove={isSwipeable ? this.mouseMoveHandler.bind(this) : null}
        onTouchMove={isSwipeable ? this.mouseMoveHandler.bind(this) : null}
        onMouseLeave={
          isSwipeable ? this.mouseMoveCompleteHandler.bind(this) : null
        }
        onTouchCancel={
          isSwipeable ? this.mouseMoveCompleteHandler.bind(this) : null
        }
      >
        {/* This overlay element is to prevent children click event */}
        <StyledOverlay ref={(overlayEl) => (this.overlayEl = overlayEl)} />
        <CarouselContent
          ref={(carouselContainerEl) =>
            (this.carouselContainerEl = carouselContainerEl)
          }
        >
          {showItems.map((i) => {
            const itemIndex = items.findIndex((a) => a.id === i.id)
            const translateX = (itemIndex - slideIndex) * 100
            return (
              <PageCarouselViewItem
                style={{
                  transform: `translateX(${translateX}%)`,
                  position: itemIndex === slideIndex ? 'static' : 'absolute',
                }}
                key={i.id}
              >
                {React.cloneElement(element, { school: i })}
              </PageCarouselViewItem>
            )
          })}
        </CarouselContent>
      </StyledCarouselView>
    )
  }
}

const EnhancedCarouselView = connect(({ screenSize }) => ({
  screenSize: screenSize.size,
}))(PageCarouselView)

export { EnhancedCarouselView as PageCarouselView }
